// extracted by mini-css-extract-plugin
export var Scheme = "index-module--Scheme--96MgH";
export var SchemeSwiper = "index-module--SchemeSwiper--7g39J";
export var SchemeSwiperHeader = "index-module--SchemeSwiperHeader--0rMOT";
export var SchemeSwiperItem = "index-module--SchemeSwiperItem--poZ55";
export var SchemeSwiperSlide = "index-module--SchemeSwiperSlide--RidlY";